import { ButtonUnstyled } from '@sketch/components'
import styled from 'styled-components'

export const Button = styled(ButtonUnstyled)`
  position: absolute;
  width: 0px;
  height: 0px;
  z-index: ${({ theme }) => theme.zIndex[8]};
`
